import { getAvatarFromIcon } from "@app/components/resources/resources_icons";
import { DEFAULT_MCP_SERVER_ICON } from "@app/lib/actions/constants";
import type { MCPServerType } from "@app/lib/api/mcp";
import type { Avatar } from "@dust-tt/sparkle";
import type { ComponentProps } from "react";

export { DEFAULT_MCP_SERVER_ICON };

// MCP-specific function
export const getAvatar = (
  mcpServer: Pick<MCPServerType, "icon">,
  size: ComponentProps<typeof Avatar>["size"] = "sm"
) => {
  return getAvatarFromIcon(mcpServer.icon, size);
};
